import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UAParser } from "ua-parser-js";
import { DPP_Public } from "../../db_access/dpp_public";
import { ProductPassportVisitLog } from "../../db_access/product_passport_visit_log";
import { dpp_format } from "../Products/DPP/ProductDPP_Format";
import DppPublicSummary from "../Products/DPP/DppPublicSummary";
const DPP_View_Published = () => {
  const { product_id } = useParams();
  const [dpp, setDPP] = useState(
    dpp_format.reduce((acc, item) => {
      acc[item.field] = item.default;
      return acc;
    }, {})
  );
  const [isLoading, setIsLoading] = useState(true);
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const getPassport = () => {
      if (!product_id) {
        setIsLoading(false);
        return;
      }
      DPP_Public.get_published_by_product_id(product_id)
        .then((res) => res.json())
        .then((data) => {
          setDPP((p) => ({ ...p, ...data.data, id: product_id }));
        })
        .finally(() => setIsLoading(false));
    };
    getPassport();
  }, [product_id]);
  useEffect(() => {
    const getPosition = () => {
      if (info) {
        return;
      }
      const parser = new UAParser();
      const result = parser.getResult();
      const deviceInfo = {
        device_type: result.device.type || "pc", // "mobile", "tablet", or "pc"
        device_os: result.os.name || "unknown", // "iOS", "Android", "Windows", "Mac OS"
      };
      // const url = "https://ipapi.co/json/"
      const url =
        "http://ip-api.com/json/?fields=status,message,continent,continentCode,country,countryCode,region,regionName,city,district,zip,lat,lon,timezone,offset,currency,isp,org,as,asname,reverse,mobile,proxy,hosting,query";
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          setInfo({
            ...data,
            ...deviceInfo,
            continent_code: data["continentCode"],
            region: data["regionName"],
            region_code: data["region"],
            postal: data["zip"],
            longitude: data["lon"],
            latitude: data["lat"],
            country_name: data["country"],
            country_code: data["countryCode"],
            network: null,
            ip: null,
            asn: null,
          });
        })
        .catch((err) => console.error(err));
    };

    getPosition();
  }, [info]);
  useEffect(() => {
    // Gated on !isLoading (not just `info`) so this can't fire before the
    // passport fetch has landed — the geolocation lookup and passport fetch
    // run in parallel with no ordering guarantee, and reading dpp.entity_type
    // before the passport arrives would silently default to "product" even
    // for a project's DPP, logging the scan into the wrong column.
    const logVisit = () => {
      if (info && !isLoading) {
        const passport = { product_id, entity_type: dpp.entity_type || "product", ...info };
        ProductPassportVisitLog.new(passport);
      }
    };
    logVisit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info, product_id, isLoading]);
  return (
    <Box>
      {isLoading ? (
        <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <CircularProgress sx={{ color: "#659d33" }} />
        </Box>
      ) : dpp._id ? (
        <DppPublicSummary dpp={dpp} entityId={product_id} />
      ) : (
        <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography sx={{ fontFamily: "Poppins", color: "#64748b" }}>DPP NOT FOUND</Typography>
        </Box>
      )}
    </Box>
  );
};
export default DPP_View_Published;
